import React from "react";
import Container from "react-bootstrap/Container";
import Typist from "react-typist-component";
import { Jumbotron } from "./migration";

const MainBody = React.forwardRef(({ title, message, icons }, ref) => {
  return (
    <Jumbotron
      fluid
      id="home"
      style={{
        background: "#000", // Solid black background
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        overflow: "hidden",
      }}
      className="bgstyle text-light m-0"
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(circle at 12% 18%, rgba(76, 201, 240, 0.18), transparent 30%), radial-gradient(circle at 86% 30%, rgba(244, 162, 97, 0.14), transparent 32%)",
          pointerEvents: "none",
        }}
      />
      <div id="stars"></div> {/* Optional: Add star animation CSS */}
      <Container
        className="text-center"
        style={{ position: "relative", zIndex: 1, maxWidth: "960px" }}
      >
        <p
          className="text-uppercase mb-3"
          style={{
            letterSpacing: "0.16em",
            fontSize: "0.78rem",
            color: "rgba(255, 255, 255, 0.72)",
          }}
        >
          {title || "Automation Engineer"}
        </p>
        <h1
          ref={ref}
          className="display-2"
          style={{
            color: "#fff",
            lineHeight: 1.12,
            textShadow: "0 8px 24px rgba(0, 0, 0, 0.35)",
            maxWidth: "860px",
            margin: "0 auto",
          }}
        >
          {message}
        </h1>
        {/* <p
          className="lead mt-3 mb-0 mx-auto"
          style={{
            maxWidth: "740px",
            color: "rgba(255, 255, 255, 0.82)",
            fontSize: "1.1rem",
          }}
        >
          I help operations-heavy businesses automate CRM handoffs, reporting,
          onboarding, and repetitive back-office work with systems reliable
          enough for daily use.
        </p> */}
        {/* <Typist>
          <div className="lead typist" style={{ color: "#fff" }}>
            {message}
          </div>
        </Typist> */}
        <div className="pt-4 pb-5">
          {icons.map((icon, index) => (
            <a
              key={`social-icon-${index}`}
              target="_blank"
              rel="noopener noreferrer"
              href={icon.url}
              aria-label={`My ${icon.image.split("-")[1]}`}
              style={{ margin: "0 10px", opacity: 0.9 }}
            >
              <i
                className={`fab ${icon.image} fa-3x socialicons`}
                style={{ color: "#fff" }}
              />
            </a>
          ))}
        </div>
        <a
          className="btn btn-lg"
          href="#getintouch"
          role="button"
          aria-label="Go to Get In Touch section"
          style={{
            border: "1px solid rgba(255, 255, 255, 0.58)",
            color: "#fff",
            background:
              "linear-gradient(135deg, rgba(76, 201, 240, 0.22), rgba(255, 255, 255, 0.08))",
            borderRadius: "999px",
            padding: "0.9rem 1.6rem",
            fontWeight: 600,
            letterSpacing: "0.02em",
            boxShadow: "0 12px 28px rgba(0, 0, 0, 0.35)",
          }}
        >
          Schedule a Free Strategy Call
        </a>
      </Container>
    </Jumbotron>
  );
});

export default MainBody;
